<div class="tree-component">
  <div class="tree-header">
    <label class="tree-header-title">{{ treeName }}</label>
    <label>
      <i
        class="icon iconfont icon-add-root list-header-icon"
        (click)="createRootCategory()"
        *ngIf="showCreateRoot"
        nz-tooltip
        [nzTooltipTitle]="'新增一级' + treeName"
        nzTooltipPlacement="bottom"
      ></i>

      <i
        class="icon iconfont icon-add-circle list-header-icon m-l-18"
        (click)="createCategory()"
        *ngIf="showCreateChild"
        nz-tooltip
        [nzTooltipTitle]="'新增' + treeName"
        nzTooltipPlacement="bottom"
      ></i>

      <i
        class="icon iconfont icon-edit list-header-icon m-l-18"
        (click)="editCategory()"
        nz-tooltip
        [nzTooltipTitle]="'编辑' + treeName"
        nzTooltipPlacement="bottom"
      ></i>

      <i
        class="icon iconfont icon-stop tree-header-icon m-l-18"
        (click)="updateCategoryStatus()"
        nz-tooltip
        [nzTooltipTitle]="'禁用' + treeName"
        nzTooltipPlacement="bottom"
        *ngIf="showDisabled && selectedValue?.origin?.state === 0"
      ></i>

      <i
        class="icon iconfont icon-check-circle tree-header-icon m-l-18"
        (click)="updateCategoryStatus()"
        nz-tooltip
        [nzTooltipTitle]="'启用' + treeName"
        nzTooltipPlacement="bottom"
        *ngIf="showDisabled && selectedValue?.origin?.state === -1"
      ></i>
    </label>
  </div>
  <div class="list-search">
    <!--  <nz-input-group [nzSuffix]="suffixIcon" *ngIf="showSearch">-->
    <input type="text" nz-input placeholder="搜索" [(ngModel)]="searchValue" />
    <!--  </nz-input-group>-->
    <!--  <ng-template #suffixIcon>-->
    <!--    <i nz-icon nzType="search"></i>-->
    <!--  </ng-template>-->
  </div>
  <nz-tree
    [nzData]="nodes"
    nzDraggable
    nzBlockNode
    #nzTreeComponent
    [nzTreeTemplate]="nzTreeTemplate"
    [nzSelectedKeys]="defaultSelectedKey"
    [nzSearchValue]="searchValue"
    [nzHideUnMatched]="true"
    [nzExpandAll]="true"
    (nzClick)="selectCategory($event)"
    (nzOnDrop)="onDrop($event)"
  ></nz-tree>
  <ng-template #nzTreeTemplate let-node let-origin="origin">
    <span class="custom-node">
      <span nz-row nzAlign="middle" *ngIf="!node.isLeaf">
        <i nz-icon [nzType]="node.origin.state === 0 ? 'check-circle' : 'stop'"></i>
        <span class="folder-name">{{ node.title }}</span>
      </span>
      <span nz-row nzAlign="middle" *ngIf="node.isLeaf">
        <i nz-icon [nzType]="node.origin.state === 0 ? 'check-circle' : 'stop'"></i>
        <span class="file-name">{{ node.title }}</span>
      </span>
    </span>
  </ng-template>
</div>
